import {inject, Injectable} from "@angular/core";

import {SecureStorageLocal} from "@app/core/shared/domain/storage/secure-storage.local";
import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";
import {Migration} from "@app/core/shared/infrastructure/migration/interfaces/migration";
import {MigrationContext} from "@app/core/shared/infrastructure/migration/interfaces/migration-context";
import {MigrationsExecutor} from "@app/core/shared/infrastructure/migration/migrations.executor";
import {
  credentialsMigration
} from "@app/core/shared/infrastructure/migration/migrations/002-secure-credentials.migration";
import {environment} from "src/environments/environment";

const migrations: Migration[] = [credentialsMigration];

const DB_VERSION_KEY = "ecommerce_db_version";

@Injectable({ providedIn: "root" })
export class MigrationService {
  private readonly storage = inject(StorageLocal);
  private readonly secureStorage = inject(SecureStorageLocal);

  async executeMigrations() {
    const context: MigrationContext = {
      oldVersion: Number(this.storage.getItem(DB_VERSION_KEY) ?? 0),
      newVersion: environment.DB_VERSION,
      platform: environment.PLATFORM,
      storage: this.storage,
      secureStorage: this.secureStorage,
    };

    await this.makeMigrations(context);
  }

  private async makeMigrations(context: MigrationContext) {
    try {
      const migrationsExecutor = new MigrationsExecutor(context, migrations);
      await migrationsExecutor.execute();

      // If has a succesfully migration, update user local db number
      this.storage.setItem(DB_VERSION_KEY, String(environment.DB_VERSION));
    } catch (error) {
      console.error("Error migrating the ecommerce db", error);
      throw Error("Error migrating the ecommerce db");
    }
  }
}
